import React from "react";
import { Link } from "react-router-dom";
import { analytics, logEvent } from "../js/firebase";
import "./SpotifyGateLanding.css";

const SPOTIFY_ARTIST_URL =
  "https://open.spotify.com/artist/786LaXEMjTkduykfZsmbox";
const SPOTIFY_TRACK_URL =
  "https://open.spotify.com/album/6fVTD5jVP8XBdFMfKV7rGj";
const YOUTUBE_JAZZ_FLAMENCO_PLAYLIST_URL =
  "https://www.youtube.com/watch?v=V4O6QCsVQnc&list=PLGZ34gicjTY8";
const GATE_DESKTOP_FALLBACK_IMAGE =
  `${process.env.PUBLIC_URL}/images/modal-promo/Red_Ocean_CTA_Image_2.png`;
const GATE_MOBILE_FALLBACK_IMAGE =
  `${process.env.PUBLIC_URL}/images/modal-promo/Red_Ocean_CTA_Image_mobile.png`;
const GATE_DESKTOP_BACKGROUND_VIDEO =
  `${process.env.PUBLIC_URL}/images/modal-promo/Red_ocean_animation.mp4`;
const GATE_MOBILE_BACKGROUND_VIDEO =
  `${process.env.PUBLIC_URL}/images/modal-promo/Red_Ocea_CTA_animation_mobile.mp4`;

function SpotifyGateLanding() {
  const isMobileViewport = window.matchMedia("(max-width: 576px)").matches;
  const gateFallbackImage = isMobileViewport
    ? GATE_MOBILE_FALLBACK_IMAGE
    : GATE_DESKTOP_FALLBACK_IMAGE;
  const gateBackgroundVideo = isMobileViewport
    ? GATE_MOBILE_BACKGROUND_VIDEO
    : GATE_DESKTOP_BACKGROUND_VIDEO;

  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get("utm_source") || "direct";
  const utmMedium = params.get("utm_medium") || "none";
  const utmCampaign = params.get("utm_campaign") || "none";
  const trafficInfo = { utm_source: utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign };

  const handleListen = () => {
    logEvent(analytics, "spotify_gate_listen_click", { song: "Red Ocean", ...trafficInfo });
    window.location.assign(SPOTIFY_TRACK_URL);
  };

  const handleFollow = () => {
    logEvent(analytics, "spotify_gate_follow_click", { artist: "Elzen", ...trafficInfo });
    window.open(SPOTIFY_ARTIST_URL, "_blank", "noopener,noreferrer");
  };

  const handleJazzFlamencoPlaylist = () => {
    logEvent(analytics, "spotify_gate_jazz_flamenco_playlist_click", { ...trafficInfo });
    window.open(YOUTUBE_JAZZ_FLAMENCO_PLAYLIST_URL, "_blank", "noopener,noreferrer");
  };

  const backgroundStyle = {
    backgroundImage: `url(${gateFallbackImage})`,
  };

  return (
    <main className="spotify-gate-page" style={backgroundStyle}>
      <video
        className="spotify-gate-video-bg"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={gateFallbackImage}
        aria-hidden="true"
      >
        <source src={gateBackgroundVideo} type="video/mp4" />
      </video>
      <div className="spotify-gate-overlay" />
      <section className="spotify-gate-panel">
        <button className="spotify-gate-title" onClick={handleListen}>
          <span className="spotify-gate-title-label">Escucha Red Ocean</span>
          <span className="spotify-gate-title-emojis" aria-hidden="true">❤️🌊</span>
        </button>

        <button className="spotify-gate-secondary-btn" onClick={handleFollow}>
          Seguirme en Spotify
        </button>

        <button
          className="spotify-gate-secondary-btn spotify-gate-youtube-btn"
          onClick={handleJazzFlamencoPlaylist}
        >
          Guitarra Jazz / Flamenco Playlist ▶️🍷☕🎶
        </button>

        <Link
          to="/website"
          className="spotify-gate-secondary-btn spotify-gate-link-btn"
          onClick={() => logEvent(analytics, "spotify_gate_website_click", { ...trafficInfo })}
        >
          Ir a WebSite Oficial
        </Link>
      </section>
    </main>
  );
}

export default SpotifyGateLanding;
